import styles from "./PageSearchResult.module.scss";
import { observer } from "mobx-react";
import ClickableLink from "../../components/utilities/ClickableLink";
import { useAnalyticsSafe } from "../../context/AnalyticsContext";

type PageSearchResultProps = {
  id: string;
  title: string;
  url: string;
  content: string;
  breadcrumbs: string;
};

const PageSearchResult = observer((props: PageSearchResultProps) => {
  const { searchContext } = useAnalyticsSafe();

  return (
    <li className={styles.result}>
      <section>
        <ClickableLink
          href={props.url}
          analyticsEvent={searchContext ? "search_result_clicked" : undefined}
          analyticsProperties={
            searchContext
              ? {
                  result_type: "pages",
                  result_id: props.id,
                  result_title: props.title,
                }
              : undefined
          }
        >
          <div>
            <h2>{props.title}</h2>
            <div className={styles.breadcrumbs}>{props.breadcrumbs}</div>
            <div className={styles.content}>
              <div dangerouslySetInnerHTML={{ __html: props.content }} />
            </div>
          </div>
        </ClickableLink>
      </section>
    </li>
  );
});

export default PageSearchResult;
